import axios from 'axios';
import config from '../config';
import { showError } from '../utils';

// Generic network call function to handle common API request patterns
function networkCall({ method, url, headers, params, data, ...extraOptions }) {
  return axios({
    method,
    url,
    headers,
    params,
    data,
    ...extraOptions,
  })
    .then((resp) => {
      const responseBody = resp.data;
      if (responseBody.message === 'success') {
        return responseBody;
      } else {
        const error = new Error('Invalid response');
        error.data = responseBody;
        throw error;
      }
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

export function getRewards(authToken) {
  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/console/rewards`,
    headers: {
      authorization: authToken,
    },
    params: {
      v: config.version,
      web: true,
    },
  });
}

export function getRewardsHistory(authToken) {
  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/fit-rewards/purchases`,
    headers: {
      authorization: authToken,
    },
  });
}

export function redeemProduct(
  productId,
  productType,
  phone,
  countryCode,
  authToken,
  address,
  city,
  pinCode
) {
  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/fit-rewards/redeem-product`,
    headers: {
      authorization: authToken,
    },
    data: {
      productId,
      type: productType,
      phone,
      countryCode,
      address,
      city,
      pinCode,
    },
  });
}
